import { Intent } from "@blueprintjs/core/lib/esm/common/intent";
import { MenuItem } from "@blueprintjs/core/lib/esm/components/menu/menuItem";
import { Spinner } from "@blueprintjs/core/lib/esm/components/spinner/spinner";
import CountResult from "common/entities/CountResult";
import DropdownSelect from "common/form/widgets/common/DropdownSelect";
import { FlexJustify } from "common/fragments/Flex";
import NonIdealState from "common/fragments/NonIdealState";
import IOption from "common/models/IOption";
import { BlockView } from "common/views/block/BlockView.view";
import { ButtonView } from "common/views/button/Button.view";
import { CheckBoxView } from "common/views/checkbox/Checkbox.view";
import { DropdownSelectView } from "common/views/dropdownSelect/DropdownSelect.view";
import PagingView from "common/views/paging/Paging.view";
import Query from "core/api/QueryComponent";
import Label from "core/components/label/Label";
import XHRResolverService from "core/service/resolver/impl/XHRResolver.service";
import { clamp } from "core/util/MathUtils";
import ServiceRegistry from "core/util/ServiceRegistry";
import { iDef } from "core/util/TypeUtils";
import { ForumToaster } from "panels/forum/forumActions";
import {default as Autocomplete} from "react-autocomplete";
import React from "react"
import styled from "styled-components";
import Field from "typegraph/dist/decorators/field/Field";
import { Question, QuestionPool, QuestionSearch, QuestionTypes } from "./entities/Institution";
import { FloatRight, NewPostDiv, SearchBox } from "./TestAssignmentList.panel";
import HtmlDefault from "common/fragments/HtmlDefault";


const StyledDiv = styled.div`
overflow: auto;
width: 100%
`
const Table = styled.table`
	border: 1px solid;
	width: 100%;
    border-color: #ececec;
`;

const TR = styled.tr`
    border-bottom: 1px solid;
    border-color: #ececec;
`;

const TH = styled.th`
	text-align: left;
	padding: 10px;
    border-right: 1px solid;
    border-color: #ececec;
`;

const TD = styled.td`
	text-align: left;
	padding: 10px;
    border-right: 1px solid;
    border-color: #ececec;
`;

const ButtonDiv = styled.div`	
	padding: 20px;
    display:flex;
    @media(max-width: 768px) {
        flex-direction: column;
        display: flex;
        flex-wrap: wrap;
        min-width: 100%;
	}
`;

const PaddingDiv = styled.div`	
	padding-right: 10px;
    padding-bottom: 5px;

`;

const Header = styled.div`	
	padding: 0px 0px 15px 80px;
    display:flex;

    & > div > span > span {
        margin: 0px 0px 0px 32px;
    }

    @media(max-width: 768px) {
        flex-direction: column;
        display: flex;
        flex-wrap: wrap;
        min-width: 100%;
        padding: 0px 0px 0px 0px;
	}
`;

const Header2 = styled.div`	
	padding: 0px 0px 15px 80px;
    display:flex;

    & > span {
        margin: 0px 0px 0px 20px;
    }

    @media(max-width: 768px) {
        flex-direction: column;
        display: flex;
        flex-wrap: wrap;
        min-width: 100%;
        padding: 0px 0px 0px 0px;
	}
`;

const EmptyDiv = styled.div`	
	padding-bottom: 5px;
    @media(max-width: 768px) {
        width: -webkit-fill-available !important;
    }
`;

interface IQuestionsState{
    view?:string;
    pageSize?:number;
	pageNumber?:number;
    selectAll?:boolean;
    checkList?:any;
    checkListData?:any;
    questionTypes?:QuestionTypes[];
    selectedType?:number;
    questNumber?:string;
    questStemQuery?:string;
    poolsList?:any;
    poolQuery?:string;
    poolId?:number;
    refreshCount?:number;
}

interface IQuestionsProps{
    assignmentId?:number,
    status?:number
}

class QuestionsQuery {
	@Field({
		entity: Question,
		params: (params) => ({params}),
		aliasFor: 'getAllQuestions'
	})
	public entities: null | Question[];

	@Field({
		entity: CountResult,
		aliasFor: "getAllQuestionsCount",
		params: (params) => ({params}),
	})
	public count: CountResult;
}

class QuestionSearchQuery {
	@Field({
		entity: QuestionSearch,
		params: (params) => ({params}),
		aliasFor: 'getAllQuestions'
	})
	public entities: null | Question[];

	@Field({
		entity: CountResult,
		aliasFor: "getAllQuestionsCount",
		params: (params) => ({params}),
	})
	public count: CountResult;
}

export class QuizQuestionsComponent extends React.PureComponent<IQuestionsProps, IQuestionsState>{

    constructor(props){
        super(props);

        this.state = {
            view:"overview",
            checkList:{},
            checkListData:{},
            pageNumber:0,
            pageSize:10,
            questionTypes:[],
            questNumber:"",
            questStemQuery:"",
            poolsList:[],
            poolQuery:"",
            poolId:0,
            refreshCount:this.getRandom()
        }
    }

    private setPageSize = (pageSize: number) =>
		this.setState({
			pageSize:pageSize,
			pageNumber:0
		});

	private setPageNumber = (pageNumber: number) =>
		this.setState({
			pageNumber:pageNumber
		});

    private handleSelectAll(val) {
        this.setState({
            selectAll:val
        })
    }

    private renderSearchResults(data: Question[] = [], id:string) {
        return (
            <StyledDiv>
                <Table>
                    <thead>
                        <TR>
                            <TH>
                                <CheckBoxView
                                    viewKey={'checkbox.all'}
                                    value={this.state.selectAll}
                                    onChange={(val) => {this.handleSelectAll(val)}}
                                    disabled={iDef(this.props.status) && this.props.status !== 0}
                                />
                            </TH>
                            <TH>
                                <strong><Label k="pool.name.header" v="Pool Name" /></strong>
                            </TH>
                            <TH>
                                <strong><Label k="question.id.header" v="Question ID" /></strong>
                            </TH>
                            <TH>
                                <strong><Label k="question.stem.header" v="Stem" /></strong>
                            </TH>
                        </TR>
                    </thead>
                    <tbody>
                        {data.map(question => (
                            <TR>
                                <TD>
                                    <CheckBoxView
                                        viewKey={'checkbox.'+question[id]}
                                        value={iDef(this.state.checkList[question[id]]) 
                                            ? this.state.checkList[question[id]] 
                                            : this.state.selectAll
                                        }
                                        onChange={(val) => { 
                                            this.setState( prevState => {
                                                let checkList = {...prevState.checkList}
                                                checkList[question[id]] = val
                                                return {checkList}
                                            })

                                            this.setState( prevState => {
                                                let checkListData = {...prevState.checkListData}
                                                checkListData[question[id]] = question
                                                return {checkListData}
                                            })

                                        }}
                                        disabled={iDef(this.props.status) && this.props.status !== 0}
                                    />
                                </TD>
                                <TD>{question.poolName}</TD>
                                <TD>{question.questionNumber}</TD>
                                <TD><HtmlDefault html={question.stem ? question.stem : "<b>[]</b>"}/></TD>
                            </TR>
                        ))}
                    </tbody>
                </Table>
            </StyledDiv>
        );
    }

    private clearState () {
        this.setState({
            selectAll:false,
            checkList:{},
            checkListData:{},
            pageNumber:0,
            pageSize:10
        })
    }

    private getRandom() {
		let min = Math.ceil(1);
		let max = Math.floor(10000000);
		let ref =  Math.floor(Math.random() * (max - min + 1)) + min;
		return ref;
	}

    private refresh() {
        this.setState({refreshCount:this.getRandom()});
    }

    private renderOverview = () => {
        const params = {
			pageSize: this.state.pageSize,
			pageNumber: this.state.pageNumber,
			assignmentId:this.props.assignmentId,
            refreshCount:this.state.refreshCount,
            selected:true
		};

        let display = (iDef(this.props.status) && this.props.status === 0) ? "flex" : "none";

        return (
            <React.Fragment>
                <ButtonDiv style={{display:display}}>
                    <PaddingDiv>
                        <ButtonView 
                            viewKey="add.question.button" 
                            onClick={() => {
                                this.setState({view:"select"})
                                this.clearState();
                                this.refresh();
                            }}
                        >
                            <Label k="add.question.button" v="Add Questions" />
                        </ButtonView>
                    </PaddingDiv>
                    <PaddingDiv>
                        <ButtonView viewKey="remove.question.button" onClick={() => this.removeQuestions()}>
                            <Label k="remove.question.button" v="Remove" />
                        </ButtonView>
                    </PaddingDiv>
                </ButtonDiv>                
                <Query.Root entity={QuestionsQuery} args={params}>
			        {({loading, data}) => {

                        let total = 0;
                        let start = 0;
                        let end = 0;

                        if (loading){
                            return <Spinner size={Spinner.SIZE_SMALL}/>
                        }
                    

                        if(!loading && (data == null || data.entities == null || data.entities.length === 0)) {
                            return (
                                <React.Fragment>
                                    <NonIdealState
                                        title={"No Data"}
                                        description={""}
                                    />
                                </React.Fragment>
                            );
                        }

                        total = data.count.count;
                        start = 1 + params.pageSize * params.pageNumber;
                        end = clamp(start, total, start + params.pageSize - 1);

                        return this.renderTable(params, start, end, total, data, "id")
                            
                    }}
                </Query.Root>
            </React.Fragment>
        )
    }

    private renderTable(params, start, end, total, data, id) {
        return (
            <React.Fragment>
                <FloatRight>
                        <BlockView viewKey="paging.info">
                            <Label
                                k="paging.results.count"
                                v="${start} - ${end} of ${total} Results"
                                args={{ start, end, total }}
                            />
                        </BlockView>
                </FloatRight>
                {this.renderSearchResults(data.entities, id)}
                <BlockView viewKey="bottom">
                    <FlexJustify>
                        <div>
                            <PagingView
                                viewKey="paging"
                                pageSize={params["pageSize"]}
                                pageNumber={params["pageNumber"]}
                                total={total}
                                setPageNumber={this.setPageNumber}
                            />
                        </div>
                        <DropdownSelectView
                            viewKey="pageSize"
                            onChange={this.setPageSize}
                            items={[10, 20]}
                            itemRenderer={(
                                size: number,
                                { handleSelect }
                            ) => {
                                return (
                                    <MenuItem
                                        key={size}
                                        text={
                                            <Label
                                                k="pageSize"
                                                v="Show ${size}"
                                                args={{ size }}
                                            />
                                        }
                                        onClick={handleSelect}
                                    />
                                );
                            }}
                        >
                            <Label
                                k="pageSize"
                                v="Show ${size}"
                                args={{ size: this.state.pageSize }}
                            />
                        </DropdownSelectView>
                    </FlexJustify>
                </BlockView>
            </React.Fragment>
        )
    }

    private renderSelect = () => {
        const params = {
			pageSize: this.state.pageSize,
			pageNumber: this.state.pageNumber,
			assignmentId:this.props.assignmentId,
            quesType:this.state.selectedType,
            questNumber:this.state.questNumber,
            questStemQuery:this.state.questStemQuery,
            questPoolId:this.state.poolId,
            refreshCount:this.state.refreshCount
		};            

        return (
            <React.Fragment>
                <Header>
                    <EmptyDiv>
                        <Label k="question.number" v="Question Number" />
                        <SearchBox
                            value={this.state.questNumber}
                            onChange={(ev)=>{this.setState({questNumber:ev.target.value})}}
                        />
                    </EmptyDiv>
                    
                    <Label k="question.type" v="Question Type" />
                    <DropdownSelect
                        options={
                            (this.state.questionTypes || []).map<IOption<number>>((type) => ({
                                value: type.id,
                                label: type.name
                            }))
                        }
                        value={this.state.selectedType}
                        onChange={val=>{
                                this.setState({selectedType:val});
                            }
                        }
                    />
                    
                </Header>
                <Header2>
                    <EmptyDiv>
                        <Label k="question.stem" v="Question Stem" />
                        <SearchBox
                            value={this.state.questStemQuery}
                            onChange={(ev)=>{this.setState({questStemQuery:ev.target.value})}}
                        />
                    </EmptyDiv>
                    
                        <Label k="question.pools" v="Question Pools" />
                        <EmptyDiv className="autocomplete-wrapper">                    
                            <Autocomplete
                            
                                value={this.state.poolQuery}
                                items={this.state.poolsList}
                                getItemValue={item => item.name}
                                shouldItemRender={(item, value) => item.name.toLowerCase()
                                    .indexOf(value.toLowerCase()) > -1}
                                renderMenu={item => (
                                    <div className="dropdown">
                                        {item}
                                    </div>
                                )}
                                renderItem={(item, isHighlighted) =>
                                    <div className={`item ${isHighlighted ? 'selected-item' : ''}`}>
                                    {item.name}
                                    </div>
                                }
                                onChange={(event, val) => {
                                    this.setState({ poolQuery : val })
                                    if (val === ""){
                                        this.setState({ poolId : 0 })
                                    }
                                }}
                                onSelect={(val,item) => this.setState({ poolQuery : val, poolId : Number.parseInt(item.id) })}
                            
                            />
                        </EmptyDiv>
                </Header2>
                <ButtonDiv>
                    <PaddingDiv>
                        <ButtonView viewKey="add.button" onClick={() => {
                            this.addQuestions();
                        }}>
                            <Label k="add.questions" v="Add" />
                        </ButtonView>
                    </PaddingDiv>
                    <PaddingDiv>
                        <ButtonView viewKey="back.button" onClick={() => {
                            this.setState({view:"overview"})
                            this.clearState();
                            this.refresh();
                        }}>
                            <Label k="back.questions" v="Back" />
                        </ButtonView>
                    </PaddingDiv>
                </ButtonDiv>
                <Query.Root entity={QuestionSearchQuery} args={params}>
			        {({loading, data}) => {

                        let total = 0;
                        let start = 0;
                        let end = 0;

                        if (loading){
                            return <Spinner size={Spinner.SIZE_SMALL}/>
                        }
                    

                        if(!loading && (data == null || data.entities == null || data.entities.length === 0)) {
                            return (
                                <React.Fragment>
                                    <NonIdealState
                                        title={"No Data"}
                                        description={""}
                                    />
                                </React.Fragment>
                            );
                        }

                        total = data.count.count;
                        start = 1 + params.pageSize * params.pageNumber;
                        end = clamp(start, total, start + params.pageSize - 1);

                        return this.renderTable(params, start, end, total, data, "questionId")
                    }}
                </Query.Root>
            </React.Fragment>
        )
    }

    private removeQuestions = () => {
        if (iDef(this.state.checkList) || this.state.selectAll){
            let data = [];
            // if all questions should be removed from all pages then in data send only those specific questions
            // which user have unchecked and should not be removed (backend will take care of that it will remove all questions other than the unchecked ones)
            if (this.state.selectAll) {
                Object.entries(this.state.checkList).map(([key, value]) => {
                    if (!value) {
                        data.push(key);
                    }
                });
            } else {
                // if only specific questions are selected then in checkedData send only those specific questions
                // (backend will take care of that it will remove only selected questions rather than all)
                Object.entries(this.state.checkList).map(([key, value]) => {
                    if (value) {
                        data.push(key);
                    }
                });
            }

            let params:string= "mutation { removeQuestions(params: {";
            params = params + "selectAll:" + this.state.selectAll;
            params = params + ", assignmentId:" + this.props.assignmentId;

            if (iDef(data) && data.length > 0) {
                params = params + ", questionIds:[";
                let isFirstTime = true;
                Object.entries(data).map(([k,v]) => {
                    if (isFirstTime){
                        isFirstTime = false;
                    } else {
                        params = params + ", ";
                    }

                    params = params + v;
                })
                params = params + "] ";
            }
            

            params = params + "}){entityId}}";
            const req = [];
			const que = ServiceRegistry.get(XHRResolverService).execute(params).then(req => {
				let reqData= JSON.parse(req);
				let data= reqData.data;
				if(reqData.errors){
					let msg = reqData.errors[0].message.split(':')[1];
                    console.log(msg);
                    ForumToaster.show({
                        intent: Intent.DANGER,
                        message: "Error occurred while removing questions!!"
                    });
				} else if(data['removeQuestions']){
					ForumToaster.show({
						intent: Intent.SUCCESS,
						message: "Questions removed successfully!!"
					});
				}
			 }).catch(err => {
				console.log(err);
			 });

             req.push(que);
             Promise.all(req)
                    .then((value) => {
                        this.refresh();
                        this.clearState();
                    })
                .catch((reason) => {
                    console.log(reason)
                    ForumToaster.show({
                        intent: Intent.DANGER,
                        message: "An error occurred while removing questions!!"
                    });
                });
        } else {
            ForumToaster.show({
                intent: Intent.DANGER,
                message: "Please select questions!!"
            });
        }
    }

    private addQuestions = () => {
        if (iDef(this.state.checkList)  || this.state.selectAll){

            let checkedData = {};

            // if all questions should be added from all pages then in checkedData send only those specific questions
            // which user have unchecked and should not be added (backend will take care of that it will add all questions other than the unchecked ones)
            if (this.state.selectAll) {
                checkedData = Object.entries(this.state.checkList).reduce((a, [key, value]) => {
                    if (!value) {
                        a[key] = value;
                    }
                    return a;
                }, {} as any);
            } else {
                // if only specific questions are selected then in checkedData send only those specific questions
                // (backend will take care of that it will add only selected questions rather than all)
                checkedData = Object.entries(this.state.checkList).reduce((a, [key, value]) => {
                    if (value) {
                        a[key] = value;
                    }
                    return a;
                }, {} as any);
            }
             

            let params:string= "mutation { addQuestions(params: { ";
            params = params + "selectAll:" + this.state.selectAll + ", ";

            // add question params
            params = params + "questionParams: { assignmentId:" + this.props.assignmentId;

            // if select all check box is checked we need to consider the filters also
            // and in backend add all those questions which satisfy these filters

            if (iDef(this.state.selectedType)) {
                params = params + ", quesType:" + this.state.selectedType;
            }

            if (this.state.questNumber && iDef(this.state.questNumber)) {
                params = params + ", questNumber:" + this.state.questNumber;
            }

            if (this.state.questStemQuery && iDef(this.state.questStemQuery)) {
               params = params + ', questStemQuery:"' + this.state.questStemQuery + '"';
            }

            if (this.state.poolId && iDef(this.state.poolId)) {
                params = params + ", questPoolId:" + this.state.poolId;
            }

            params = params + " } ,";

            params = params + " questions:[";
            let isFirstTime = true;
			Object.entries(checkedData).map(([key, val]) => {
                let d = this.state.checkListData[key]
                if (iDef(d)){
                    const {__typename, questionNumber, poolName, stem, ...data} = d;
                    if (isFirstTime){
                        isFirstTime = false;
                    } else {
                        params = params + ", ";
                    }
                    params = params + " { ";
                    let isFirst = true;
                    Object.entries(data).map(([key, val]) => {
                        if (isFirst){
                            isFirst = false;
                        } else {
                            params = params + ", ";
                        }
                        if(typeof val === "string"){
                            params = params + key+":\""+val+"\" ";
                        } else if(Array.isArray(val)){
                            params = params + key+":["+val+"] ";
                        }
                        else  params = params + key+": "+val+" "; 
                    })
                    params = params + " } ";
                }
            })

            params= params+"]";
	
			params= params+ " }) { entityId } } ";

            const req = [];
			const que = ServiceRegistry.get(XHRResolverService).execute(params).then((req) => {
				
                    let reqData= JSON.parse(req);
                    let data= reqData.data;
                    if(reqData.errors){
                        let msg = reqData.errors[0].message.split(':')[1];
                        console.log(msg);
                        ForumToaster.show({
                            intent: Intent.DANGER,
                            message: "Error occurred while adding questions!!"
                        });
                    } else if(data['addQuestions']){
                        ForumToaster.show({
                            intent: Intent.SUCCESS,
                            message: "Questions Added Successfully!!"
                        });
                    }
                }).catch(err => {
                    console.log(err);
                    ForumToaster.show({
                        intent: Intent.DANGER,
                        message: "An error occurred while adding questions!!"
                    });
                });
                req.push(que);
                Promise.all(req)
                    .then((value) => {
                        this.setState({view:"overview"})
                        this.clearState();
                        this.refresh();
                    })
                .catch((reason) => {
                    console.log(reason)
                    ForumToaster.show({
                        intent: Intent.DANGER,
                        message: "An error occurred while adding questions!!"
                    });
                });
        } else {
            ForumToaster.show({
                intent: Intent.DANGER,
                message: "Please select questions!!"
            });
        }        
    }

    private async getQuestionTypes() {
        const res : any = await ServiceRegistry.getQueryService().findMany(QuestionTypes, {});
        let data = res && res.data && res.data.entities || [];
        let types = [];
        types.push({id:-1, name:"All"});
        data.map(type => {
            types.push({id:type.id, name:type.name});
        })
        
        this.setState({
            questionTypes:types,
            selectedType:-1
            })
	}

    private async getQuestionPools() {
		if (iDef(this.props.assignmentId)) {
			const res : any = await ServiceRegistry.getQueryService().findMany(QuestionPool, {id:this.props.assignmentId});
			let data = res && res.data && res.data.entities || [];
                       
			this.setState({
				poolsList:data
			  })
		}
	}

    public async componentDidMount() {
        this.refresh();
		this.getQuestionTypes();
        this.getQuestionPools();
	}

    public render() {

        switch(this.state.view) {
			case "overview":
				return this.renderOverview();
			case "select":
				return (
					<React.Fragment>
						{this.renderSelect()}
					</React.Fragment>
				);
			default:
				return null;
		}

    }
}


// WEBPACK FOOTER //
// ./src/panels/testAssignment/QuizQuestionsComponent.tsx